import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CommonModulesForCountriesComponent } from 'src/app/commonModulesForCountries/common-modules-for-countries/common-modules-for-countries.component';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-add-bussiness-rules',
  templateUrl: './add-bussiness-rules.component.html',
  styleUrls: ['./add-bussiness-rules.component.scss']
})
export class AddBussinessRulesComponent implements OnInit, AfterViewInit {


  @ViewChild(CommonModulesForCountriesComponent, { static: false }) commonCountryCompnent: CommonModulesForCountriesComponent;

  titleHeader = 'Add Business';
  businessForm: FormGroup;
  communityName: string;
  tarriffArrayDetails: any;
  editData: any;
  loadLater: boolean;
  searchSelected: boolean;

  constructor(private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }



  ngOnInit(): void {
    this.createForm();
    if (this.data.type !== 'Creation') {
      this.titleHeader = 'Edit Bussiness';
      console.log(' this.data.dataValues ', this.data.dataValues);
      this.editData = this.data.dataValues;
      this.setFormValues();
      this.getTarriff1();
    }
    this.communityName = sessionStorage.getItem('userCommunity');
    //this.getTarriff();
  }


  createForm() {
    this.businessForm = this.formBuilder.group({
      communityName: [],
      country: [],
      network: [],
      vistingCountry: ['1'],
      visitingNetwork: ['1'],
      ecowasEnabled: [],
      messageEnabled: [],
      chargingEnabled: [],
      whitelistEnabled: [],
      iotAssigned: [],
      tariffName: ['1'],
      freeRoamValidity: ['', [Validators.pattern("^[0-9]*$")]],
      counterValidity: ['', [Validators.pattern("^[0-9]*$")]],
      messageInterval: ['', [Validators.pattern("^[0-9]*$")]],
      stayHomeInterval: ['', [Validators.pattern("^[0-9]*$")]],
      counterStayHomeInterval: ['', [Validators.pattern("^[0-9]*$")]],
      ratesApplied: ['', [Validators.pattern("^[0-9]*$")]],
      MOC: [],
      MTC: [],
      SMSMO: [],
      GPRS: [],
      dataOthers: [],
      homeTadIg: [],
      visitingTadIg: [],
      mocNoOfDaysApplied: [],
      mtcNoOfDaysApplied: [],
      smsmoNoOfDaysApplied: [],
      gprsNoOfDaysApplied: [],
      dataNoOfDaysApplied: [],
      tariffId: [],
      communityId: [],
      sno: []
    });
  }

  ngAfterViewInit() {
    if (this.commonCountryCompnent) {
      if (this.businessForm) {
        console.log(this.businessForm.value);
        this.commonCountryCompnent.setDropDownValues(this.businessForm.get('vistingCountry').value, this.businessForm.get('visitingNetwork').value, null, null, null, null);
        this.loadLater = true;
        
      }
    }
  }

  setFormValues() {
    this.businessForm.patchValue({
      vistingCountry: this.editData.vistingCountry,
      visitingNetwork: this.editData.vistingNetwork,
      chargingEnabled: this.editData.chargingEnabled,
      counterStayHomeInterval: this.editData.counterStayHomeInterval,
      counterValidity: this.editData.counterValidity,
      country: this.editData.country,
      dataNoOfDaysApplied: this.editData.dataNoOfDaysApplied,
      dataOthers: this.editData.dataOthers,
      date: this.editData.date,
      ecowasEnabled: this.editData.ecowasEnabled,
      freeRoamValidity: this.editData.freeRoamValidity,
      gprsNoOfDaysApplied: this.editData.gprsNoOfDaysApplied,
      GPRS: this.editData.grps,
      iotAssigned: this.editData.iotAssigned,
      messageEnabled: this.editData.messageEnabled,
      messageInterval: this.editData.messageInterval,
      MOC: this.editData.moc,
      mocNoOfDaysApplied: this.editData.mocNoOfDaysApplied,
      MTC: this.editData.mtc,
      mtcNoOfDaysApplied: this.editData.mtcNoOfDaysApplied,
      network: this.editData.network,
      SMSMO: this.editData.smsmo,
      smsmoNoOfDaysApplied: this.editData.smsmoNoOfDaysApplied,
      sno: this.editData.sno,
      stayHomeInterval: this.editData.stayHomeInterval,
      tariffName: this.editData.tariffName,
      tarrifId: this.editData.tarrifId,
      ratesApplied: this.editData.ratesApplied
    });
  }

  selectedValues(event) {
    if (this.loadLater) {
      console.log(event);
      if (event.vpmnNetwork) {
        this.businessForm.patchValue({
          visitingNetwork: event.vpmnNetwork
        })
      }
      if (event.vpmnCountry) {
        this.businessForm.patchValue({
          vistingCountry: event.vpmnCountry
        })
      }
      this.getTarriff();
    }
  }

  getTarriff() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_TARRIF_ID + '&country=' + this.businessForm.get('vistingCountry').value
    + '&network=' + this.businessForm.get('visitingNetwork').value
    + '&userOrgId=' + sessionStorage.getItem('userOrgId');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.tarriffArrayDetails = response;
      console.log(this.tarriffArrayDetails);
    });
  }
  getTarriff1() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_TARRIF_ID 
    + '&userOrgId=' + sessionStorage.getItem('userOrgId');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.tarriffArrayDetails = response;
      console.log(this.tarriffArrayDetails);
    });
  }

  getValuesAccordingToTariff(event: any) {
    this.tarriffArrayDetails.forEach(element => {
      if ((element.tarrifName) == (event.target.value)) {
        this.businessForm.controls.MOC.setValue(element['moCallHome']);
        this.businessForm.controls.MTC.setValue(element['moCallVisited']);
        this.businessForm.controls.GPRS.setValue(element['gprs']);
        this.businessForm.controls.dataOthers.setValue(element['moCallOther']);
        this.businessForm.controls.SMSMO.setValue(element['moSms']);
      }
    });
  }

  get f() {
    return this.businessForm.controls;
  }

  createBussinessData(type) {
    console.log(this.businessForm.value);
    this.searchSelected = true;
    if (this.businessForm.valid && this.businessForm.get('vistingCountry').value != 'All' 
    && this.businessForm.get('visitingNetwork').value !='All' && this.businessForm.get('tariffName').value !='1') {
    let apiurl = (type === 'Edit' ? this.endpointsService.URL_UPDATE_BUSINESS_RULES : this.endpointsService.URL_INSERT_BUSINESS_RULES) +
      '&country=' + this.businessForm.get('vistingCountry').value +
      '&network=' + this.businessForm.get('visitingNetwork').value + '_' + this.businessForm.get('vistingCountry').value +
      '&vistingCountry=' + this.businessForm.get('vistingCountry').value +
      '&vistingNetwork=' + this.businessForm.get('visitingNetwork').value +
      '&userOrgId=' + sessionStorage.getItem('userOrgId') +
      '&communityName=' + sessionStorage.getItem('userCommunity') +
      '&ecowasEnabled=' + (this.businessForm.get('ecowasEnabled').value ? 'Y' : 'N') +
      '&chargingEnabled=' + (this.businessForm.get('chargingEnabled').value ? 'Y' : 'N') +
      '&messageEnabled=' + (this.businessForm.get('messageEnabled').value ? 'Y' : 'N') +
      '&iotAssigned=' + (this.businessForm.get('iotAssigned').value ? 'Y' : 'N') +
      '&whitelistEnabled=' + (this.businessForm.get('whitelistEnabled').value ? 'Y' : 'N') +
      '&freeRoamValidity=' + this.businessForm.get('freeRoamValidity').value +
      '&counterValidity=' + this.businessForm.get('counterValidity').value +
      '&messageInterval=' + this.businessForm.get('messageInterval').value +
      '&stayHomeInterval=' + this.businessForm.get('stayHomeInterval').value +
      '&counterStayHomeInterval=' + this.businessForm.get('counterStayHomeInterval').value +
      '&ratesApplied=' + this.businessForm.get('ratesApplied').value +
      '&moc=' + this.businessForm.get('MOC').value +
      '&mtc=' + this.businessForm.get('MTC').value +
      '&sms-mo=' + this.businessForm.get('SMSMO').value +
      '&grps=' + this.businessForm.get('GPRS').value +
      '&dataOthers=' + this.businessForm.get('dataOthers').value +
      '&mocNoOfDaysApplied=' + this.businessForm.get('mocNoOfDaysApplied').value +
      '&mtcNoOfDaysApplied=' + this.businessForm.get('mtcNoOfDaysApplied').value +
      '&smsmoNoOfDaysApplied=' + this.businessForm.get('smsmoNoOfDaysApplied').value +
      '&gprsNoOfDaysApplied=' + this.businessForm.get('gprsNoOfDaysApplied').value +
      '&dataNoOfDaysApplied=' + this.businessForm.get('dataNoOfDaysApplied').value +
      '&tariffName=' + this.businessForm.get('tariffName').value +
      '&tarrifId=' + '&communityId=';
    if (type === 'Edit') {
      apiurl = apiurl + '&sno=' + this.businessForm.get('sno').value;
    }
    console.log(apiurl);
    this.backendApiService.callToApi(apiurl).subscribe(response => {
      this.spinnerService.hide();
      if (response) {
        if (type === 'Edit') {
          alert('Updated Business Successfully');
        } else {
          alert('Added Business Successfully');
        }
        this.closeModal();
      } else {
        alert('Failed to add/update Bussiness');
        this.closeModal();
      }
    });
  }

  else{
    alert("Please Select VPMN Country & VPMN Network & Tariff Name");
    return;
  }
}

  closeModal() {
    this.dialog.closeAll();
  }

  updateCampaign() {

  }

}
